import React from 'react';

import { SymbolsTable } from '@gitbook/expr';
import { getVariableValueType, type RevisionPageDocument } from '@gitbook/hive-core';

import { ExpressionProvider } from '../../../Components';

/**
 * Provide the context for dynamic expressions in a page.
 */
export function PageExpressionContext(
    props: React.PropsWithChildren<{ page: RevisionPageDocument }>
) {
    const { page, children } = props;

    const expressionContext = React.useMemo(() => {
        return {
            inputValues: {
                page: {
                    vars: page.variables ?? {},
                },
            },
            symbolsTable: new SymbolsTable({
                page: SymbolsTable.inferSymbolFromJSONSchema(
                    {
                        type: 'object',
                        description: 'The attributes tied to the current page.',
                        properties: {
                            vars: {
                                type: 'object',
                                description: 'The variables set on the page.',
                                properties: Object.fromEntries(
                                    Object.entries(page.variables ?? {}).map(([key, value]) => [
                                        key,
                                        {
                                            type: getVariableValueType(value),
                                            description: `The value of the variable ${key}.`,
                                        },
                                    ])
                                ),
                            },
                        },
                        required: ['vars'],
                    },
                    'page'
                ),
            }),
        };
    }, [page.variables]);

    return <ExpressionProvider {...expressionContext}>{children}</ExpressionProvider>;
}
